export default __webpack_public_path__ + "static/media/Empty-pana 1.22a73ec2.png";